import styled, { css } from 'styled-components';
import { MParagraphAlignment } from './MParagraph.types';

export const Wrapper = styled.div<{ alignment?: MParagraphAlignment }>`
  ${({ alignment }) => css`
    text-align: ${alignment === MParagraphAlignment.Center ? 'center' : 'left'};
    margin: 0 auto;
    width: 100%;
  `}
`;

export const ParagraphContent = styled.div`
  display: inline;
`;

export const TruncationControl = styled.div`
  display: flex;
  justify-content: end;
`;
